import React from 'react';
import { ImageInfo } from '../data/dataType';
import Image from 'next/image';

export const getImageUrl = (image: ImageInfo): string => {
    if (!image.bucket) {
        return image.src;
    }
    return `${process.env.NEXT_PUBLIC_SUPABASE_URL}/storage/v1/object/public/${image.bucket}/${image.folder}/${image.itemId}/images/${image.name}`;
};

const NextImage: React.FC<{
    image: ImageInfo;
    className?: string;
    priority?: boolean;
    alt?: string;
    maxHeight?: number;
    sizes?: string;
    style?: React.CSSProperties;
    lazy?: 'eager' | 'lazy';
}> = ({
    image,
    className = '',
    priority = false,
    alt = '',
    maxHeight,
    sizes,
    style,
    lazy = 'eager',
}) => {
    if (!image) {
        return null;
    }

    let imageHeight = image?.height || 0;
    let imageWidth = image?.width || 0;

    if (maxHeight) {
        imageHeight = maxHeight;
        imageWidth = Math.round((image?.width / image?.height) * maxHeight);
    }

    const imageSrc = getImageUrl(image);

    return image.fill ? (
        <Image
            alt={alt}
            className={className}
            fill
            loading={lazy}
            priority={priority}
            sizes={sizes || '100vw'}
            src={imageSrc}
            style={style}
        />
    ) : (
        <Image
            alt={alt}
            className={className}
            height={imageHeight}
            loading={lazy}
            priority={priority}
            sizes={sizes || '100vw'}
            src={imageSrc}
            style={style}
            width={imageWidth}
        />
    );
};

export default NextImage;
